import { NotificationAlert, Table } from '../../../components';
import { assignedMenteescolumns } from './columns';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import {
  quarterReviewStatuses,
  statusColors,
  statusesLabel,
} from '../../../helper';
import {
  getQuarter,
  getQuarterlyUsers,
} from '../../../services/reviewsServices';
import dayjs from 'dayjs';
import { quarterlyUsers } from '../../../types';

const AssignedMentees = () => {
  // const { state } = useLocation();
  const { id } = useLocation().state;
  const myRef = useRef<any>();
  const [reviewData, setReviewData] = useState({
    'Start Date': '-',
    'End Date': '-',
    'Mentee Deadline': '-',
    'Mentor Deadline': '-',
    Name: '',
  });
  const [data, setData] = useState<quarterlyUsers[]>([]);
  const [loading, setLoading] = useState(true);

  // fetch quarter details
  const fetchReviewData = async () => {
    const { data, error } = await getQuarter(id || '', 'mentor');
    if (error) return myRef.current?.call('error', error?.message);
    const status = quarterReviewStatuses[data?.status || 0];
    setReviewData({
      'Start Date': dayjs(data?.startDate).format('MMM DD YYYY'),
      'End Date': dayjs(data?.endDate).format('MMM DD YYYY'),
      'Mentee Deadline': dayjs(data?.menteeDeadline).format('MMM DD YYYY'),
      'Mentor Deadline': dayjs(data?.mentorDeadline).format('MMM DD YYYY'),
      [status]: data?.progress,
      Name: data?.name || '',
    });
  };

  // fetch quarter users
  const fetchQuarterusers = async () => {
    setLoading(true);
    const { data, error } = await getQuarterlyUsers(id, 'mentor');
    setLoading(false);
    if (error) return myRef.current?.call('error', error?.message);
    if (data) setData(data);
  };

  useEffect(() => {
    fetchReviewData();
    fetchQuarterusers();
  }, []);

  return (
    <div className="flex flex-col gap-y-[10px]">
      <div className="text-[20px] font-[500] p-[10px]">{reviewData?.Name}</div>
      <div className="flex gap-x-[10px] p-[10px]">
        {Object.entries(reviewData).map((value, idx: number) => {
          if (value[0] === 'Name') return null;
          if (statusesLabel[value[0]]) {
            return (
              <div
                key={idx}
                style={{ background: `${statusColors[value[0]] || ''}` }}
                className="flex flex-col gap-y-1 rounded-[5px] text-white p-[10px]"
              >
                <div>{statusesLabel[value[0]]}</div>
                <div className="text-base font-bold">{`${value[1]}% Complete`}</div>
              </div>
            );
          }
          return (
            <div className="flex flex-col gap-y-1 p-[10px]" key={idx}>
              <div className="opacity-50">{value[0]}</div>
              <div className="opacity-85">{value[1]}</div>
            </div>
          );
        })}
      </div>
      <Table
        columns={assignedMenteescolumns(true, reviewData.Name, id)}
        data={data}
        errorFetchingData={false}
        loading={loading}
        rowKey={(data) => data.user.id}
      />
      <NotificationAlert ref={myRef} />
    </div>
  );
};

export default AssignedMentees;
